import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import TextField from "./TextField";
import { MenuItem } from "@mui/material";
import React from "react";
import { isArray } from "lodash";

const ComboSelectSimpleTextFiled = React.forwardRef((props, ref) => {
    const { options, emptyValue, emptyLabel, SelectProps, multiple, MenuProps, renderValue, selectStyle, value, ...others } = props;
    return (
        <TextField
            {...others}
            ref={ref}
            select
            SelectProps={{
                multiple,
                MenuProps,
                renderValue,
                ...SelectProps,
            }}
            value={options && isArray(options) && options.length > 0 ? value : ''}>
            {others.value === emptyValue && !isEmpty(emptyValue) &&
                <MenuItem value={emptyValue} disabled>
                    <em style={{ color: '#BDBDBD' }}>{emptyLabel ? emptyLabel : "Seleccione..."}</em>
                </MenuItem>
            }
            {options && options.map(record => {
                return (
                    <MenuItem key={record.value} value={record.value} disabled={record.disabled || false} style={{ height: 'auto' }}>
                        {record.text}
                    </MenuItem>
                )
            })}
        </TextField>
    )
});

ComboSelectSimpleTextFiled.displayName = "ComboSelectSimpleTextFiled";

const ComboSelectWithMoreInfo = React.forwardRef((props, ref) => {
    const { moreInfo, key, ...others } = props;
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }} key={key}>
            <ComboSelectSimpleTextFiled {...others} ref={ref} />
            {moreInfo}
        </div>
    )
});

ComboSelectWithMoreInfo.displayName = "ComboSelectWithMoreInfo";

const ComboSelect = React.forwardRef((props, ref) => {
    if (props.moreInfo)
        return <ComboSelectWithMoreInfo {...props} ref={ref} />
    else
        return <ComboSelectSimpleTextFiled {...props} ref={ref} />
});

ComboSelect.propTypes = {
    label: PropTypes.string,
    // id: PropTypes.string.isRequired,
    //field: PropTypes.string.isRequired,
    required: PropTypes.bool,
};

ComboSelect.defaultProps = {
    //margin: 'none',
    required: false,
    color: 'secondary',
    size: null, //'small',
    fullWidth: true,
    variant: 'outlined',
    selectStyle: null,
};

ComboSelect.displayName = "ComboSelect";

export default ComboSelect;